import { render, staticRenderFns } from "./CollateralManagement.vue?vue&type=template&id=7a6cf612&scoped=true&"
import script from "./CollateralManagement.vue?vue&type=script&lang=js&"
export * from "./CollateralManagement.vue?vue&type=script&lang=js&"
import style0 from "./CollateralManagement.vue?vue&type=style&index=0&id=7a6cf612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6cf612",
  null
  
)

export default component.exports